<template>
    <div class="mb-xs">
        <b class="minicart-title">{{ group.name }}</b>
        <template v-if="group.type === constant.type.vats || group.type === constant.type.product">
            <div
                class="order-unit"
                :data-element="'order-unit-' + item.type.toLowerCase()"
                :key="item.id"
                v-for="item in displayItems"
            >
                <span>{{ item.name }}</span>
            </div>
        </template>
        <template v-else-if="group.type === constant.type.mgp">
            <div
                class="order-unit"
                :data-element="'order-unit-' + item.type.toLowerCase()"
                :key="item.id"
                v-for="item in displayItems"
            >
                <span>{{ item.name }} руб./мин.</span>
            </div>
        </template>
        <template v-else-if="isNumberGroup">
            <div :style="numberGroupStyle" class="minicart-scroll">
                <transition-group name="slide-fade" tag="div">
                    <div
                        class="order-unit"
                        :data-element="'order-unit-' + item.type.toLowerCase()"
                        :key="item.id"
                        v-for="item in displayItems"
                    >
                        <span><span class="prefix">{{ item.prefix }}</span>{{ item.number }}</span>
                        <a
                            href=""
                            class="order-unit_del"
                            data-element="remove-cross"
                            v-if="group.canDelete"
                            @click.prevent="remove(item)"
                        >
                            <svg class="icon icon--close"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--close"></use></svg>
                        </a>
                    </div>
                </transition-group>
            </div>
            <div v-if="showMoreLink">
                <a
                    href=""
                    data-element="numbers-more-open"
                    @click.prevent="toggleMore"
                >{{ moreLinkTitle }}</a>
            </div>
        </template>
        <template v-else>
            <div
                class="order-unit"
                :data-element="'order-unit-' + item.type.toLowerCase()"
                :key="item.id"
                v-for="item in displayItems"
            >
                {{ item.name }}
            </div>
        </template>
    </div>
</template>

<script>
import ModelCart from '../models/cart';
import ModelCartGroup from '../models/cart_group';

export default {
    name: "MiniCartGroup",
    props: {
        group: {
            type: ModelCartGroup
        }
    },
    data () {
        return {
            constant: ModelCart.constants,
            numbersLimit: 5,
            moreIsShown: false
        }
    },
    computed: {
        isNumberGroup () {
            return [
                ModelCart.constants.type.numbers,
                ModelCart.constants.type.fmcNumbers,
                ModelCart.constants.type.mvnoNumbers,
                ModelCart.constants.type.portingNumbers
            ].indexOf(this.group.type) > -1
        },
        showMoreLink () {
            return this.isNumberGroup && this.displayItems.length > this.numbersLimit
        },
        moreLinkTitle () {
            if (this.showMoreLink) {
                if (this.moreIsShown) {
                    return 'свернуть'
                } else {
                    return 'ещё ' + (this.displayItems.length - this.numbersLimit)
                }
            }
            return null
        },
        numberGroupStyle () {
            if (this.isNumberGroup) {
                let style = {
                    overflow: 'auto',
                };
                style['max-height'] = '217px';
                if (!this.moreIsShown) {
                    style['max-height'] = this.numbersLimit * 30 + 'px';
                    style['overflow'] = 'hidden';
                }
                return style;
            }
            return null;
        },

        displayItems () {
            let items = this.group.items;
            for (let k in items) {
                if (
                    ['NUMBERS', 'FMC_NUMBERS', 'MVNO_NUMBERS', 'PORTING_NUMBERS'].indexOf(items[k]['type']) > -1
                ) {
                    let arName = items[k]['name'].split(')');
                    items[k]['prefix'] = arName[0] + ')';
                    items[k]['number'] = arName[1];
                }
            }
            return items;
        }
    },
    methods: {
        toggleMore () {
            this.moreIsShown = !this.moreIsShown;
            let resizeEvent = new Event('resize');
            window.dispatchEvent(resizeEvent);
        },
        remove (item) {
            this.$emit('remove', item);
            let resizeEvent = new Event('resize');
            window.dispatchEvent(resizeEvent);
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/transition/slide-fade';
</style>